import { IFriendReferralQualified } from "interfaces";
import { FeatureType } from "interfaces/feature-tracker";
import { baseApi } from "../api";

export const friendInviteAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getFriendReferralQualified: builder.query<IFriendReferralQualified, void>({
			query: () => "/rest/friend/referral/qualified",
			providesTags: () => [{ type: "friendInviteFriendsTag" }]
		}),
		createFriendReferral: builder.mutation<
			void,
			{ friendUserId: string; friendName: string }
		>({
			query: ({ friendUserId, friendName }) => ({
				url: "/rest/friend/referral/create",
				method: "POST",
				body: { friendUserId, friendName }
			}),
			invalidatesTags: () => [{ type: "friendInviteFriendsTag" }]
		}),
		acceptedReferral: builder.mutation({
			query: ({ referralId }) => {
				return {
					url: "/rest/friend/referral/accept",
					method: "POST",
					body: { referralId }
				};
			} /* ,
			invalidatesTags: () => [
				{ type: "featureTrackerTag", id: FeatureType.FRIEND_REFERRAL }
			] */
		}),
		postFrTrackerMetadata: builder.mutation({
			query: (body: { [key: string]: string | number | boolean }) => {
				const queryParams = new URLSearchParams();
				for (const [key, value] of Object.entries(body)) {
					queryParams.append(key, value.toString());
				}
				return {
					url: `/rest/friend/referral/metadata/tracker/value?${queryParams.toString()}`,
					method: "POST"
					//body
				};
			},
			/* async onQueryStarted(body, { dispatch, queryFulfilled }) {
				await queryFulfilled;
				dispatch(
					baseApi.util.updateQueryData(
						"getFeatureTracker" as never,
						{
							FeatureType: FeatureType.FRIEND_REFERRAL,
							isAuthenticated: true
						} as never,
						(draft: { tracker?: { metadata?: Record<string, unknown> } }) => {
							if (draft.tracker?.metadata) {
								draft.tracker.metadata[body.key as string] = body.value;
							}
						}
					)
				);
			}, */
			invalidatesTags: () => [
				{ type: "featureTrackerTag", id: FeatureType.FRIEND_REFERRAL }
			]
		})
	})
});

export const {
	useAcceptedReferralMutation,
	useCreateFriendReferralMutation,
	usePostFrTrackerMetadataMutation,
	useGetFriendReferralQualifiedQuery
} = friendInviteAPI;
